import React from 'react'

/**
 * Utility function to cast refs to the type expected by Chakra UI components
 * This is needed because Chakra UI expects non-null refs, but React.useRef can be null
 */
export const castRef = <T extends HTMLElement>(
  ref: React.RefObject<T | null>,
): React.RefObject<T> => {
  return ref as React.RefObject<T>
}
